<template>
    <div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
      <HeadNav selectedLanguage="en" page="instasave"  
          :gotodownload="gotodownload"
          :apk="apk"/>
      <div id="page" class="site container hfeed">
        <div id="content" class="site-content">
          <div id="primary" class="content-area">
            <main id="maincontent" class="site-main">
              <!-- Hero Section -->
              <HeroSection 
                :title="heroTitle"
                :subtitle="heroSubtitle"
                :input-placeholder="inputPlaceholder"
                :active-tab="activeTab"
                @tab-change="switchTab"
                @download-content="downloadContent"
                @go-to-download="goToDownload"
                @join-telegram="joinTelegramChannel"
              />
              <div class="home-wrapper">
               
    
                <!-- How to Download Section -->
                <HowToSection
                  :title="'Instagram से वीडियो और फ़ोटो कैसे डाउनलोड करें - InstaSave'"
                  :steps="howToSteps"
                />
    
                <!-- Why Use InstaSave Section -->
                <section class="why-use-section">
                  <h2 class="section-title">Instagram (IG) डाउनलोड के लिए Instasave क्यों इस्तेमाल करें?</h2>
                  <ul class="benefits-list">
                    <li>
                      <h3>अनलिमिटेड डाउनलोड</h3>
                      <p>न इंस्टॉल करने की ज़रूरत, न ही लॉगिन की। आप जितने चाहें उतने वीडियो और फ़ोटो रोज़ बिना किसी लिमिट के डाउनलोड कर सकते हैं।</p>
                    </li>
                    <li>
                      <h3>100% गुमनाम</h3>
                      <p>मोबाइल और डेस्कटॉप दोनों पर काम करता है। Instagram से ब्राउज़ और डाउनलोड करते समय आपका कोई भी निजी डेटा शेयर नहीं होता।</p>
                    </li>
                    <li>
                      <h3>तेज़ और पूरी तरह फ्री</h3>
                      <p>पोस्ट, Reels, कैरोसेल फ़ोटो और कुछ पब्लिक स्टोरी लिंक के लिए सपोर्ट। हमारी सेवा ऑटोमैटिक, तेज़, सुरक्षित और 100% मुफ्त है।</p>
                    </li>
                  </ul>
                </section>
    
                <!-- App Recommendation Section -->
                <AppRecommendationSection 
                  :title="appRecommendationTitle"
                  :description="appRecommendationDescription"
                  :button-text="appRecommendationButtonText"
                  :image-src="appRecommendationImageSrc"
                  :image-alt="appRecommendationImageAlt"
                  @go-to-download="goToDownload"
                />
    
                <!-- Why Choose Online First Section -->
                <section class="choice-section">
                  <div class="choice-card">
                    <h3>ऑनलाइन पहले और InstaSave ऐप बाद में क्यों चुनें?</h3>
                    <ul>
                      <li><strong>Online:</strong> कभी-कभार सेव करने के लिए सबसे तेज़ तरीका, कोई इंस्टॉलेशन नहीं, हर डिवाइस पर काम करता है।</li>
                      <li><strong>ऐप:</strong> हेवी यूज़र्स के लिए बेहतर — एक साथ कई डाउनलोड, बैकग्राउंड मोड, ऑफ़लाइन गैलरी और स्मार्ट फ़ाइल नाम।</li>
                      <li>अगर आप अपना अनुभव शेयर करना चाहते हैं, नए तरीक़े सीखना चाहते हैं या Instagram कंटेंट डाउनलोड से जुड़े सवालों का हल ढूँढ रहे हैं, तो <a href="https://freegbdownload.com/" class="jump-url" target="_blank">GB WhatsApp</a> ग्रुप में जुड़ सकते हैं।</li>
                    </ul>
              </div>
                </section>
    
                <!-- Features Sections -->
                <FeaturesGrid :features="features" />
    
                <!-- FAQ Section -->
                <section class="faq-section">
                  <h2 class="section-title">FAQ & Troubleshooting</h2>
                  <div class="faq-container">
                    <div v-for="(faq, index) in faqs" :key="index" class="faq-item">
                      <div class="faq-question" @click="toggleFaq(index)">
                        <div style="font-size: 1.2rem; font-weight: 600;">{{ faq.question }}</div>
                        <span class="faq-toggle">{{ expandedFaqs.includes(index) ? '−' : '+' }}</span>
                      </div>
                      <div v-if="expandedFaqs.includes(index)" class="faq-answer">
                        <p v-html="faq.answer"></p>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </main> 
          </div>
        </div>
      </div>
    
    </div>
    </template>
    
    <script>
    import '@/css/base.scss';
    import '@/css/index.scss';
    import HeadNav from '@/components/HeadNav.vue';
    import Footer from '@/components/Footer.vue';
    import HeroSection from '@/components/HeroSection.vue';
    import HowToSection from '@/components/HowToSection.vue';
    import FeaturesGrid from '@/components/FeaturesGrid.vue';
    import AppRecommendationSection from '@/components/AppRecommendationSection.vue';
    
    export default {
      name: 'Home',
      components: {
        HeadNav,
        Footer,
        HeroSection,
        HowToSection,
        FeaturesGrid,
        AppRecommendationSection
      },
      head() {
        return {
          title: 'InstaSave – Instagram वीडियो और फ़ोटो डाउनलोड',
          meta: [
            {
              hid: 'description',
              name: 'description',
              content: 'InstaSave की मदद से आप आसानी से Instagram के वीडियो और फ़ोटो ऑनलाइन डाउनलोड कर सकते हैं। लिंक पेस्ट करें, डाउनलोड पर क्लिक करें और अपना पसंदीदा IG कंटेंट हाई क्वालिटी में सेव करें।'
            },
            {
              hid: 'keywords',
              name: 'keywords',
              content: 'Instagram वीडियो डाउनलोड, instasave, Instagram फ़ोटो डाउनलोडर'
            }
          ]
        }
      },
      data() {
        return {
          pageName: 'home',
          instagramLink: '',
          expandedFaqs: [],
          activeTab: '',
          heroTitle: 'InstaSave – Instagram डाउनलोडर',
          heroSubtitle: 'बस Instagram लिंक पेस्ट करें और डाउनलोड बटन पर क्लिक करें',
          inputPlaceholder: 'लिंक यहाँ पेस्ट करें',
          appRecommendationTitle: 'InstaSave: Android पर Instagram डाउनलोड करें (ऐप रिकमेंडेशन)',
          appRecommendationDescription: 'अगर आप अक्सर कंटेंट सेव करते हैं तो ऐप ज़्यादा सुविधाजनक है। InstaSave Android के लिए बना है और स्पीड, बल्क डाउनलोड और साफ़-सुथरी गैलरी पर फोकस करता है।',
          appRecommendationButtonText: 'InstaSave मुफ़्त में डाउनलोड करें',
          appRecommendationImageSrc: require('@/assets/home/home-1.webp'),
          appRecommendationImageAlt: 'InstaSave App',
          faqs: [
            {
              question: "क्या डाउनलोड करने के लिए मुझे लॉगिन करना होगा?",
              answer: "ऑनलाइन टूल से ज़्यादातर पब्लिक पोस्ट के लिए नहीं। कुछ स्टोरी या प्राइवेट कंटेंट के लिए आपको Instagram ऐप में पहले से ऐक्सेस होना चाहिए; जब आप ऐसा लिंक शेयर करते हैं जिसे आप देख सकते हैं, तो हमारा Android ऐप मदद कर सकता है।"
            },
            {
              question: "डाउनलोड किए गए वीडियो में आवाज़ नहीं है, क्यों?",
              answer: "कुछ म्यूज़िक लाइसेंस्ड होते हैं, जिन्हें थर्ड-पार्टी टूल्स के साथ शामिल नहीं किया जा सकता। अगर ऐप में \"ओरिजिनल ऑडियो\" जैसा कोई विकल्प हो तो वहीं से डाउनलोड करें, या क्रिएटर से दूसरी वर्ज़न (इजाज़त के साथ) सेव करें।"
            },
            {
              question: "सेव करने के बाद वीडियो धुंधला क्यों दिखता है?",
              answer: "Instagram मीडिया को कंप्रेस करता है। डाउनलोड करते समय उपलब्ध सबसे अच्छी क्वालिटी चुनें। Android में Instasave की सेटिंग में \"Prefer HD\" विकल्प ऑन रखें।"
            },
            {
              question: "क्या मैं प्राइवेट अकाउंट से भी डाउनलोड कर सकता/सकती हूँ?",
              answer: "सिर्फ़ तब जब आप उस अकाउंट को फॉलो करते हों और ऐप में कंटेंट देख पाते हों — फिर लिंक को Instasave के साथ शेयर/कॉपी करें। प्राइवेसी सेटिंग्स को कभी भी बायपास करने की कोशिश न करें।"
            },
            {
              question: "मेरे डाउनलोड किए गए फ़ाइलें कहाँ सेव होती हैं?",
              answer: "डेस्कटॉप: आपके ब्राउज़र के Downloads फ़ोल्डर में।<br>Android: Internal storage › Pictures/Movies › Instasave (जिसे सेटिंग में बदला जा सकता है)।<br>iPhone (ऑनलाइन टूल): Files ऐप या Photos में (आपके सेव करने के तरीके पर निर्भर करता है)।"
            },
            {
              question: "\"Invalid\" लिंक क्यों दिखा रहा है?",
              answer: "ध्यान रखें कि आपने पूरा URL कॉपी किया हो (बीच में कोई extra space न हो)। Instagram दोबारा खोलें, Share › Copy Link पर टैप करें और यहाँ फिर से पेस्ट करें।"
            },
            {
              question: "क्या इस ऐप की वजह से मेरा अकाउंट बैन हो सकता है?",
              answer: "हम कभी भी आपका Instagram पासवर्ड नहीं माँगते। फिर भी, हमेशा Instagram के नियमों का पालन करें और केवल वही कंटेंट डाउनलोड करें जिसकी अनुमति हो।"
            },
            {
              question: "क्या मैं शेड्यूल या बैच डाउनलोड कर सकता/सकती हूँ?",
              answer: "हाँ — Android पर आप Instasave में कई लिंक पेस्ट कर सकते हैं, या क्लिपबोर्ड ऑटो-कैप्चर ऑन करके फ़ाइलों की क्यू बना सकते हैं।"
            },
            {
              question: "क्या यह कैरोसेल और हाइलाइट्स के लिए भी काम करता है?",
              answer: "हाँ। ऑनलाइन टूल में आप अलग-अलग आइटम चुन सकते हैं, और ऐप में \"Download all\" विकल्प से सबकुछ एक साथ सेव कर सकते हैं।"
            },
            {
              question: "क्या यह सर्विस फ्री है?",
              answer: "ऑनलाइन डाउनलोडर और Android के लिए Instasaver, दोनों मुफ़्त उपलब्ध हैं।"
            }
          ],
          howToSteps: [
            {
              title: "स्टेप 1: Instagram लिंक कॉपी करें",
              items: [
                "Instagram ऐप या वेबसाइट खोलें।",
                "किसी पोस्ट, Reel, Story हाइलाइट या IGTV पर तीन डॉट (या Share) आइकन पर टैप करें।",
                "\"Copy Link\" विकल्प चुनें।"
              ]
            },
            {
              title: "स्टेप 2: लिंक पेस्ट करें",
              items: [
                "यहाँ वापस आएँ और लिंक को डाउनलोड बॉक्स में पेस्ट करें।"
              ]
            },
            {
              title: "स्टेप 3: वीडियो/फ़ोटो डाउनलोड करें",
              items: [
                "\"Download\" पर क्लिक करें।",
                "वीडियो या फ़ोटो चुनें (अगर कैरोसेल है तो फ़ाइलें अलग-अलग चुनें)।",
                "अपने डिवाइस में सेव करें (मोबाइल: Files/Photos, डेस्कटॉप: Downloads फ़ोल्डर)।"
              ]
            }
          ],
          features: [
            {
              title: "Instagram वीडियो डाउनलोड करें",
              description: "हमारे ऑनलाइन टूल की मदद से आप सिर्फ़ एक क्लिक में Instagram वीडियो डाउनलोड कर सकते हैं। वीडियो का लिंक कॉपी करें, बॉक्स में पेस्ट करें और MP4 फ़ॉर्मेट में सीधे अपने डिवाइस पर सेव करें। किसी अतिरिक्त सॉफ़्टवेयर की ज़रूरत नहीं, मोबाइल और डेस्कटॉप दोनों पर काम करता है।",
              imageSrc: require('@/assets/home/home-2.webp'),
              imageAlt: "Instagram वीडियो डाउनलोड"
            },
            {
              title: "Instagram फ़ोटो डाउनलोड करें",
              description: "हमारे डाउनलोडर से आप Instagram की फ़ोटो हाई रेज़ॉल्यूशन में तेज़ी से सेव कर सकते हैं। चाहे एक फ़ोटो हो या पूरा कैरोसेल पोस्ट, बस लिंक पेस्ट करें और तुरंत इमेज सेव करें। तेज़, आसान और पूरी तरह ऑनलाइन।",
              imageSrc: require('@/assets/home/home-3.webp'),
              imageAlt: "Instagram फ़ोटो डाउनलोड"
            },
            {
              title: "Instagram स्टोरी सेवर",
              description: "हमारा Instagram Story Saver आपको स्टोरी गायब होने से पहले सेव करने देता है। स्टोरी का लिंक कॉपी करें, टूल में पेस्ट करें और सीधे अपने फ़ोन या कंप्यूटर में डाउनलोड करें। हाइलाइट्स और पब्लिक स्टोरी के लिए बिना लॉगिन के काम करता है।",
              imageSrc: require('@/assets/home/home-4.webp'),
              imageAlt: "Instagram स्टोरी सेवर"
            },
            {
              title: "Instagram Reels डाउनलोड करें",
              description: "Reels को ऑफ़लाइन रखना चाहते हैं? हमारा Instagram Reels डाउनलोड फ़ीचर आपको किसी भी Reel को MP4 फ़ाइल के रूप में सेव करने देता है। बस Reel लिंक पेस्ट करें और हाई क्वालिटी में डाउनलोड करें, ताकि आप कभी भी, कहीं भी देख सकें।",
              imageSrc: require('@/assets/home/home-5.webp'),
              imageAlt: "Instagram Reels डाउनलोड"
            },
            {
              title: "Instagram पोस्ट डाउनलोड",
              description: "Instagram पोस्ट डाउनलोड विकल्प के साथ आप पूरी पोस्ट सेव कर सकते हैं — फ़ोटो, वीडियो या कैरोसेल एल्बम सहित। बस पोस्ट का लिंक कॉपी करें और यहाँ पेस्ट करें, और पोस्ट की सारी मीडिया तुरंत डाउनलोड करें।",
              imageSrc: require('@/assets/home/home-6.webp'),
              imageAlt: "Instagram पोस्ट डाउनलोड"
            },
            {
              title: "IGTV डाउनलोड",
              description: "हमारा IGTV डाउनलोड फ़ीचर लंबे Instagram वीडियो सेव करना आसान बनाता है। IGTV लिंक कॉपी करें, डाउनलोडर में पेस्ट करें और MP4 फ़ॉर्मेट में वीडियो पा लें ताकि आप ऑफ़लाइन भी देख सकें। ट्यूटोरियल, शोज़ और इंटरव्यूज़ के लिए बेहतरीन।",
              imageSrc: require('@/assets/home/home-7.webp'),
              imageAlt: "IGTV डाउनलोड"
            }
          ]
        };
      },
      computed: {
        currentTabTitle() {
          const currentTab = this.navTabs.find(tab => tab.id === this.activeTab);
          return currentTab ? currentTab.title : 'Instagram Download';
        }
      },
      methods: {
        switchTab(tabId) {
          this.activeTab = tabId;
          console.log('Switching to tab:', tabId);
        },
        pasteFromClipboard() {
          if (navigator.clipboard && navigator.clipboard.readText) {
            navigator.clipboard.readText().then(text => {
              this.instagramLink = text;
            }).catch(err => {
              console.error('Failed to read clipboard contents: ', err);
            });
              } else {
            // Fallback for older browsers
            alert('Please paste the link manually');
          }
        },
        downloadContent() {
          // 直接下载APK文件，参考instagram-apk-download页面的实现
          let apkUrl = 'https://apk.instasaves.io/app/android/apk/Instagram_367.0.0.44.74.apk';
          this.$global.download(apkUrl);
          console.log('Downloading APK:', apkUrl);
        },
        toggleFaq(index) {
          const expandedIndex = this.expandedFaqs.indexOf(index);
          if (expandedIndex > -1) {
            this.expandedFaqs.splice(expandedIndex, 1);
              } else {
            this.expandedFaqs.push(index);
              }
        },
        gotodownload() {
          // 直接下载APK文件
          let apkUrl = 'https://apk.instasaves.io/app/android/apk/Instagram_367.0.0.44.74.apk';
          this.$global.download(apkUrl);
          console.log('Download APK:', apkUrl);
        },
        goToDownload() {
          // 跳转到下载页面
          this.$router.push('/instagram-apk-downlad/');
        },
        joinTelegramChannel() {
          // 跳转到Telegram频道
          window.open('https://t.me/+M75kow80SlQ1MjZl', '_blank');
        },
      },
    };
    </script>
    
    <style scoped>
    
    .home-wrapper {
      max-width: 1000px;
      margin: 0 auto;
      margin-top: 1rem;
    }
    
    /* Hero Section - 重新设计 */
    .hero-section {
      background: linear-gradient(80deg, #D009FF 0%, #3b82f6 100%);
      color: white;
      padding: 60px 20px 80px;
      text-align: center;
      margin-bottom: 40px;
      position: relative;
      overflow: hidden;
    }
    
    .hero-content {
      max-width: 1000px;
      margin: 0 auto;
    }
    
    /* Logo - 移除，因为图片中没有显示logo */
    .hero-logo {
      display: none;
    }
    
    /* Navigation Tabs */
    .nav-tabs {
      display: flex;
      justify-content: center;
      gap: 8px;
      margin-bottom: 50px;
      flex-wrap: wrap;
      background: rgba(255, 255, 255, 0.15);
      backdrop-filter: blur(10px);
      padding: 8px;
      border-radius: 30px;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 50px;
    }
    
    .nav-tab {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 10px 16px;
      background: transparent;
      border: none;
      border-radius: 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      flex: 1;
      justify-content: center;
    }
    
    .nav-tab:hover {
      background: rgba(255, 255, 255, 0.1);
      color: white;
    }
    
    .nav-tab.active {
      background: rgba(255, 255, 255, 0.25);
      color: white;
      font-weight: 600;
    }
    
    .tab-icon {
      font-size: 14px;
    }
    
    .tab-text {
      font-weight: inherit;
    }
    
    /* Main Title */
    .hero-title {
      font-size: 2.8rem;
      font-weight: 600;
      color: white;
      text-shadow: 1px 1px 2px rgba(0,0,0,0.2);
      letter-spacing: -0.5px;
    }
    
    /* Input Section */
    .paste-link-container {
      max-width: 600px;
      margin: 0 auto;
    }
    
    .coming-soon-note {
      text-align: center;
      margin-top: 15px;
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      font-style: italic;
      opacity: 0.9;
    }
    
    .action-buttons {
      display: flex;
      gap: 15px;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      flex-wrap: wrap;
    }
    
    .download-app-btn {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      border: none;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
    }
    
    .download-app-btn:hover {
      background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
    }
    
    .telegram-btn {
      background: transparent;
      color: white;
      border: 2px solid rgba(255, 255, 255, 0.3);
      padding: 0px 22px;
      height: min-content;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s ease;
    }
    
    .telegram-btn:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(255, 255, 255, 0.6);
      transform: translateY(-2px);
    }
    
    .btn-icon {
      width: 34px;
      height: 34px;
      object-fit: contain;
    }
    
    .input-group {
      display: flex;
      gap: 0;
      background: white;
      padding: 4px;
      border-radius: 12px;
      box-shadow: 0 8px 25px rgba(0,0,0,0.15);
      align-items: center;
      border: 1px solid rgba(0,0,0,0.05);
    }
    
    .link-input {
      flex: 1;
      border: none;
      padding: 16px 20px;
      font-size: 15px;
      border-radius: 8px;
      outline: none;
      background: transparent;
      color: #333;
    }
    
    .link-input::placeholder {
      color: #9ca3af;
      font-weight: 400;
    }
    
    .paste-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 12px 16px;
      background: #e5e7eb;
      color: #6b7280;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s ease;
      font-size: 13px;
      font-weight: 500;
      margin-right: 4px;
    }
    
    .paste-btn:hover {
      background: #d1d5db;
      color: #374151;
    }
    
    .paste-icon {
      font-size: 14px;
    }
    
    .download-btn {
      background: #ef4444;
      color: white;
      border: none;
      padding: 16px 24px;
      border-radius: 8px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
    }
    
    .download-btn:hover {
      background: #dc2626;
      box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
    }
    
    /* Section Styles - 简洁的标题设计 */
    .section-title {
      text-align: center;
      margin-bottom: 40px;
      color: #333;
    }
    
    
    /* Why Use Section - 浅灰背景 */
    .why-use-section {
      padding: 40px 20px;
      background: #f8f9fa;
    }
    
    .benefits-list {
      max-width: 1000px;
      margin: 0 auto;
      list-style: none;
      padding: 0;
      /* display: grid; */
      /* grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); */
      gap: 40px;
    }
    
    .benefits-list li {
      margin-bottom: 20px;
      background: white;
      padding: 40px 30px;
      border-radius: 20px;
      box-shadow: 0 8px 25px rgba(0,0,0,0.08);
      font-size: 16px;
      color: #555;
      text-align: left;
      position: relative;
      padding-left: 80px;
      transition: all 0.3s ease;
      border: 1px solid rgba(102, 126, 234, 0.1);
      list-style: none;
    }
    
    .benefits-list li:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 35px rgba(0,0,0,0.12);
      border-color: rgba(102, 126, 234, 0.2);
    }
    
    .benefits-list li::before {
      content: '';
      position: absolute;
      top: 30px;
      left: 15px;
      width: 50px;
      height: 50px;
      border-radius: 15px;
      background: linear-gradient(135deg, #667eea, #764ba2);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: white;
      font-weight: bold;
      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
    }
    
    .benefits-list li:nth-child(1)::before {
      content: '∞';
      background: linear-gradient(135deg, #667eea, #764ba2);
    }
    
    .benefits-list li:nth-child(2)::before {
      content: '👤';
      background: linear-gradient(135deg, #f093fb, #f5576c);
    }
    
    .benefits-list li:nth-child(3)::before {
      content: '⚡';
      background: linear-gradient(135deg, #4facfe, #00f2fe);
    }
    
    .benefits-list li h3 {
      margin: 0 0 15px 0;
      font-size: 1.3rem;
      font-weight: 700;
      color: #2c3e50;
    }
    
    .benefits-list li p {
      margin: 0;
      line-height: 1.6;
      color: #666;
    }
    
    /* App Recommendation Section */
    
    /* Choice Section - 白色背景 */
    .choice-section {
      padding: 30px 20px;
      background: white;
    }
    
    .choice-card {
      max-width: 800px;
      margin: 0 auto 30px;
      background: #f8f9fa;
      padding: 30px;
      border-radius: 8px;
      border: 1px solid #e9ecef;
    }
    
    .choice-card h3 {
      font-size: 1.4rem;
      margin-bottom: 20px;
      color: #333;
      font-weight: 600;
    }
    
    .choice-card ul {
      list-style: none;
      padding: 0;
    }
    
    .choice-card li {
      padding: 12px 0;
      color: #666;
      font-size: 18px;
      border-bottom: 1px solid #e9ecef;
    }
    
    .choice-card li:last-child {
      border-bottom: none;
    }
    
    .choice-image {
      /* text-align: center; */
      width: 230px;
      height: 230px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .choice-image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
      border: 1px solid #e9ecef;
    }
    
    
    /* FAQ Section - 现代化折叠设计 */
    .faq-section {
      padding: 20px 20px;
      background: white;
      margin-bottom: 20px;
    }
    
    .faq-container {
      max-width: 800px;
      margin: 0 auto;
    }
    
    .faq-item {
      background: white;
      margin-bottom: 20px;
      border-radius: 15px;
      box-shadow: 0 5px 15px rgba(0,0,0,0.1);
      overflow: hidden;
      transition: box-shadow 0.3s ease;
    }
    
    .faq-item:hover {
      box-shadow: 0 8px 25px rgba(0,0,0,0.15);
    }
    
    .faq-question {
      padding: 25px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: background-color 0.3s ease;
    }
    
    .faq-question:hover {
      background: #f8f9fa;
    }
    
    .faq-question h3 {
      margin: 0;
      font-size: 1.2rem;
      color: #2c3e50;
      font-weight: 600;
    }
    
    .faq-toggle {
      font-size: 1.5rem;
      font-weight: bold;
      color: #667eea;
      transition: transform 0.3s ease;
    }
    
    .faq-item.expanded .faq-toggle {
      transform: rotate(45deg);
    }
    
    .faq-answer {
      padding: 0 25px 25px;
      color: #555;
      line-height: 1.6;
        font-size: 16px;
      }
      
    /* Responsive Design */
    @media (max-width: 768px) {
      .hero-section {
        padding: 40px 20px 60px;
      }
      
      .logo-sss {
        font-size: 2rem;
      }
      
      .logo-instagram {
        font-size: 1.5rem;
      }
      
      .nav-tabs {
        gap: 6px;
        margin-bottom: 40px;
        padding: 6px;
        border-radius: 25px;
      }
      
      .nav-tab {
        padding: 8px 12px;
        font-size: 11px;
      }
      
      .hero-title {
        font-size: 2rem;
        margin-bottom: 40px;
      }
      
      .input-group {
        flex-direction: column;
        gap: 8px;
        border-radius: 12px;
        padding: 12px;
      }
      
      .link-input, .paste-btn, .download-btn {
        border-radius: 8px;
        width: 100%;
      }
      
      .paste-btn {
        margin-right: 0;
        margin-bottom: 8px;
      }
      
      .section-title {
        font-size: 1.8rem;
      }
      
      
      .app-content {
        grid-template-columns: 1fr;
        gap: 30px;
      }
      
      .app-image {
        width: 200px;
        height: 200px;
      }
      
      
      .feature-image {
        width: 200px;
        height: 200px;
      }
      
      .choice-image {
        width: 200px;
        height: 200px;
      }
      
      .choice-card {
        padding: 25px;
      }
      
      .benefits-list {
        grid-template-columns: 1fr;
        gap: 30px;
      }
      
      .benefits-list li {
        padding: 30px 25px;
        padding-left: 70px;
      }
      
      .benefits-list li::before {
        width: 45px;
        height: 45px;
        top: 25px;
        left: 20px;
        font-size: 20px;
      }
      
      .faq-question {
        padding: 20px;
      }
      
      .faq-answer {
        padding: 0 20px 20px;
    }
    }
    </style>
    